import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VForm,
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: { submit: _vm.onSubmit },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("div", [
            _c("b", [
              _vm._v(
                _vm._s(
                  _vm._f("joinTableReference")(
                    _vm.tplToWork.item.tableReference
                  )
                )
              ),
            ]),
          ]),
          _c("hr"),
          _c(
            VTabs,
            {
              attrs: { grow: "" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                VTab,
                {
                  on: {
                    click: function ($event) {
                      _vm.current = "General"
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("my_tasks.modals.general")))]
              ),
              _c(
                VTab,
                {
                  on: {
                    click: function ($event) {
                      _vm.current = "Columns"
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("my_tasks.modals.columns")))]
              ),
              _c(
                VTab,
                {
                  on: {
                    click: function ($event) {
                      _vm.current = "bterm"
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("my_tasks.modals.bterm")))]
              ),
              _vm.source == "bigquery"
                ? _c(
                    VTab,
                    {
                      on: {
                        click: function () {
                          _vm.openTab("Profile")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("my_tasks.modals.profiling")))]
                  )
                : _vm._e(),
              _c(
                VTab,
                {
                  on: {
                    click: function () {
                      _vm.openTab("Logs")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("my_tasks.modals.hlogs")))]
              ),
            ],
            1
          ),
          _c(
            VTabsItems,
            {
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                VTabItem,
                { staticClass: "pt-2" },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.ORGANIZATION.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.organization"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _vm.isEdited("ORGANIZATION")
                                    ? _c(VSelect, {
                                        attrs: {
                                          items: _vm.organizations,
                                          dense: "",
                                          outlined: "",
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .ORGANIZATION.name
                                            ].stringValue,
                                          disabled:
                                            !_vm.isEdited("ORGANIZATION"),
                                          rules:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                                .name
                                            ].enumValue.displayName == "prod"
                                              ? [
                                                  function (v) {
                                                    return (
                                                      _vm.organizations.includes(
                                                        v
                                                      ) ||
                                                      _vm.$t(
                                                        "my_tasks.modals.required"
                                                      )
                                                    )
                                                  },
                                                  function (v) {
                                                    return (
                                                      !!v ||
                                                      _vm.$t(
                                                        "my_tasks.modals.required"
                                                      )
                                                    )
                                                  },
                                                ]
                                              : [],
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .ORGANIZATION.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ORGANIZATION.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue",
                                        },
                                      })
                                    : _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          placeholder: "Enter Value",
                                          readonly:
                                            !_vm.isEdited("ORGANIZATION"),
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .ORGANIZATION.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .ORGANIZATION.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.domain")
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.selectDomain,
                                      dense: "",
                                      outlined: "",
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                        ].stringValue,
                                      disabled: !_vm.isEdited("DOMAIN"),
                                      "item-value": "text",
                                      rules:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                            .name
                                        ].enumValue.displayName == "prod"
                                          ? [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                              function (v) {
                                                return (
                                                  _vm.selectDomain.some(
                                                    function (item) {
                                                      return item.text === v
                                                    }
                                                  ) ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ]
                                          : [],
                                    },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                        ].stringValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS.DOMAIN.name
                                          ],
                                          "stringValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.DOMAIN.name].stringValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.subdomain"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.filterSubdomain,
                                      dense: "",
                                      outlined: "",
                                      disabled: !_vm.isEdited("SUBDOMAIN"),
                                      "item-value": "text",
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN.name
                                        ].stringValue,
                                      rules:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                            .name
                                        ].enumValue.displayName == "prod"
                                          ? [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                              function (v) {
                                                return (
                                                  _vm.filterSubdomain.some(
                                                    function (item) {
                                                      return item.text === v
                                                    }
                                                  ) ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ]
                                          : [],
                                    },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN.name
                                        ].stringValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS.SUBDOMAIN
                                              .name
                                          ],
                                          "stringValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.SUBDOMAIN.name].stringValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.official_source"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VTextField, {
                                    ref: "offsource",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      readonly:
                                        !_vm.isEdited("OFFICIAL_SOURCE"),
                                      rules:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                            .name
                                        ].enumValue.displayName == "prod"
                                          ? [
                                              function (v) {
                                                return (
                                                  (v !== "Null" && !!v) ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ]
                                          : [],
                                    },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE
                                            .name
                                        ].stringValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS
                                              .OFFICIAL_SOURCE.name
                                          ],
                                          "stringValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.OFFICIAL_SOURCE.name].stringValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.OPERATOR.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.operator")
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: _vm.isEdited("OPERATOR"),
                                      filled: !_vm.isEdited("OPERATOR"),
                                      readonly: !_vm.isEdited("OPERATOR"),
                                      rules: _vm.isEdited("OPERATOR")
                                        ? [
                                            _vm.rules.required,
                                            _vm.rules.emailFormat,
                                          ]
                                        : [],
                                      "error-messages": _vm.isEdited("OPERATOR")
                                        ? _vm.operatorValidator.state.errors
                                        : [],
                                      loading:
                                        _vm.operatorValidator.state.loading,
                                      disabled:
                                        _vm.operatorValidator.state.loading,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.isEdited("OPERATOR") &&
                                          _vm.operatorValidator.validate(
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.OPERATOR
                                                .name
                                            ].stringValue
                                          )
                                      },
                                      input: function ($event) {
                                        _vm.isEdited("OPERATOR") &&
                                          (_vm.operatorValidator.state.errors =
                                            [])
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.OPERATOR.name
                                        ].stringValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS.OPERATOR.name
                                          ],
                                          "stringValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.public")
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VCheckbox, {
                                    attrs: {
                                      value: true,
                                      disabled:
                                        !_vm.isEdited("PUBLIC") ||
                                        _vm.isFohAssignmentFlow,
                                    },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                        ].boolValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS.PUBLIC.name
                                          ],
                                          "boolValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.PUBLIC.name].boolValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.environment"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items:
                                        _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                          .enumValues,
                                      dense: "",
                                      outlined: "",
                                      disabled: !_vm.isEdited("ENVIRONMENT"),
                                    },
                                    on: { change: _vm.changeEnviroment },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                            .name
                                        ].enumValue.displayName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                              .name
                                          ].enumValue,
                                          "displayName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _vm.defaultFields[
                                    _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                  ]
                                    ? _c(
                                        VSubheader,
                                        {
                                          staticClass: "font-weight-bold pa-0",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("my_tasks.modals.zone")
                                            ) + ":"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(VSelect, {
                                    attrs: {
                                      items: _vm.select_zones,
                                      dense: "",
                                      outlined: "",
                                      disabled: !_vm.isEdited("ZONE"),
                                      rules:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT
                                            .name
                                        ].enumValue.displayName == "prod"
                                          ? [
                                              function (v) {
                                                return (
                                                  _vm.select_zones.includes(
                                                    v
                                                  ) ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  _vm.$t(
                                                    "my_tasks.modals.required"
                                                  )
                                                )
                                              },
                                            ]
                                          : [],
                                    },
                                    model: {
                                      value:
                                        _vm.defaultFields[
                                          _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                        ].stringValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.defaultFields[
                                            _vm.DEFAULT_TPL_FIELDS.ZONE.name
                                          ],
                                          "stringValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "defaultFields[DEFAULT_TPL_FIELDS.ZONE.name].stringValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      false
                        ? _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _vm.defaultFields[
                                _vm.DEFAULT_TPL_FIELDS.AREA.name
                              ]
                                ? _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-4" },
                                        [
                                          _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold pa-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("my_tasks.modals.area")
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        { staticClass: "col-md-8" },
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              items: _vm.select_areas,
                                              dense: "",
                                              outlined: "",
                                              disabled:
                                                !_vm.isEdited("AREA") ||
                                                !_vm.isPublicTable,
                                            },
                                            model: {
                                              value:
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS.AREA
                                                    .name
                                                ].stringValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.defaultFields[
                                                    _vm.DEFAULT_TPL_FIELDS.AREA
                                                      .name
                                                  ],
                                                  "stringValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "defaultFields[DEFAULT_TPL_FIELDS.AREA.name].stringValue",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.defaultFields[
                        _vm.DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name
                      ]
                        ? _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.bus_data_steward"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined:
                                            _vm.isEdited("BUS_DATA_STEWARD"),
                                          filled:
                                            !_vm.isEdited("BUS_DATA_STEWARD"),
                                          readonly:
                                            !_vm.isEdited("BUS_DATA_STEWARD"),
                                          rules: _vm.isEdited(
                                            "BUS_DATA_STEWARD"
                                          )
                                            ? [_vm.rules.emailRequired]
                                            : [],
                                          "error-messages": _vm.isEdited(
                                            "BUS_DATA_STEWARD"
                                          )
                                            ? _vm.busDataStewardValidator.state
                                                .errors
                                            : [],
                                          loading:
                                            _vm.busDataStewardValidator.state
                                              .loading,
                                          disabled:
                                            _vm.busDataStewardValidator.state
                                              .loading,
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.isEdited("BUS_DATA_STEWARD") &&
                                              _vm.busDataStewardValidator.validate(
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .BUS_DATA_STEWARD.name
                                                ].stringValue
                                              )
                                          },
                                          input: function ($event) {
                                            _vm.isEdited("BUS_DATA_STEWARD") &&
                                              (_vm.busDataStewardValidator.state.errors =
                                                [])
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .BUS_DATA_STEWARD.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .BUS_DATA_STEWARD.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.BUS_DATA_STEWARD.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.defaultFields[_vm.DEFAULT_TPL_FIELDS.DATA_OWNER.name]
                        ? _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.data_owner"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: _vm.isEdited("DATA_OWNER"),
                                          filled: !_vm.isEdited("DATA_OWNER"),
                                          readonly: !_vm.isEdited("DATA_OWNER"),
                                          rules: _vm.isEdited("DATA_OWNER")
                                            ? [_vm.rules.emailRequired]
                                            : [],
                                          "error-messages": _vm.isEdited(
                                            "DATA_OWNER"
                                          )
                                            ? _vm.dataOwnerValidator.state
                                                .errors
                                            : [],
                                          loading:
                                            _vm.dataOwnerValidator.state
                                              .loading,
                                          disabled:
                                            _vm.dataOwnerValidator.state
                                              .loading,
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.isEdited("DATA_OWNER") &&
                                              _vm.dataOwnerValidator.validate(
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .DATA_OWNER.name
                                                ].stringValue
                                              )
                                          },
                                          input: function ($event) {
                                            _vm.isEdited("DATA_OWNER") &&
                                              (_vm.dataOwnerValidator.state.errors =
                                                [])
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.DATA_OWNER
                                                .name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .DATA_OWNER.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.DATA_OWNER.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.defaultFields[
                        _vm.DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name
                      ]
                        ? _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        { staticClass: "font-weight-bold p-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.tech_data_custodiam"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: _vm.isEdited(
                                            "TECH_DATA_CUSTODIAM"
                                          ),
                                          filled: !_vm.isEdited(
                                            "TECH_DATA_CUSTODIAM"
                                          ),
                                          readonly: !_vm.isEdited(
                                            "TECH_DATA_CUSTODIAM"
                                          ),
                                          rules: _vm.isEdited(
                                            "TECH_DATA_CUSTODIAM"
                                          )
                                            ? [_vm.rules.emailRequired]
                                            : [],
                                          "error-messages": _vm.isEdited(
                                            "TECH_DATA_CUSTODIAM"
                                          )
                                            ? _vm.techDataCustodiamValidator
                                                .state.errors
                                            : [],
                                          loading:
                                            _vm.techDataCustodiamValidator.state
                                              .loading,
                                          disabled:
                                            _vm.techDataCustodiamValidator.state
                                              .loading,
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.isEdited(
                                              "TECH_DATA_CUSTODIAM"
                                            ) &&
                                              _vm.techDataCustodiamValidator.validate(
                                                _vm.defaultFields[
                                                  _vm.DEFAULT_TPL_FIELDS
                                                    .TECH_DATA_CUSTODIAM.name
                                                ].stringValue
                                              )
                                          },
                                          input: function ($event) {
                                            _vm.isEdited(
                                              "TECH_DATA_CUSTODIAM"
                                            ) &&
                                              (_vm.techDataCustodiamValidator.state.errors =
                                                [])
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .TECH_DATA_CUSTODIAM.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .TECH_DATA_CUSTODIAM.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.TECH_DATA_CUSTODIAM.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.defaultFields[_vm.DEFAULT_TPL_FIELDS.FINAL_TABLE.name]
                        ? _c(
                            VCol,
                            { attrs: { sm: "12", lg: "4" } },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _vm.defaultFields[
                                        _vm.DEFAULT_TPL_FIELDS.FINAL_TABLE.name
                                      ]
                                        ? _c(
                                            VSubheader,
                                            {
                                              staticClass:
                                                "font-weight-bold p-0",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.final_table"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VCheckbox, {
                                        attrs: {
                                          dense: "",
                                          value: true,
                                          disabled:
                                            !_vm.isEdited("FINAL_TABLE"),
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS.FINAL_TABLE
                                                .name
                                            ].boolValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .FINAL_TABLE.name
                                              ],
                                              "boolValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.FINAL_TABLE.name].boolValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name
                          ]
                            ? _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        {
                                          staticClass: "font-weight-bold pa-0",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.upload_platform"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          readonly:
                                            !_vm.isEdited("UPLOAD_PLATFORM"),
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .UPLOAD_PLATFORM.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .UPLOAD_PLATFORM.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.UPLOAD_PLATFORM.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name
                          ]
                            ? _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        {
                                          staticClass: "font-weight-bold pa-0",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.upload_process"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          readonly:
                                            !_vm.isEdited("UPLOAD_PROCESS"),
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .UPLOAD_PROCESS.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .UPLOAD_PROCESS.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.UPLOAD_PROCESS.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "4" } },
                        [
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name
                          ]
                            ? _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        VSubheader,
                                        {
                                          staticClass: "font-weight-bold pa-0",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.load_logic"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          readonly:
                                            !_vm.isEdited("TABLE_LOAD_LOGIC"),
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .TABLE_LOAD_LOGIC.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .TABLE_LOAD_LOGIC.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.TABLE_LOAD_LOGIC.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { sm: "12", lg: "12", md: "12" } },
                        [
                          _vm.defaultFields[
                            _vm.DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name
                          ]
                            ? _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(
                                        VSubheader,
                                        {
                                          staticClass: "font-weight-bold pa-0",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "my_tasks.modals.tables_relationship"
                                              )
                                            ) + ":"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(VTextarea, {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          readonly: !_vm.isEdited(
                                            "TABLES_RELATIONSHIP"
                                          ),
                                          rows: "2",
                                        },
                                        model: {
                                          value:
                                            _vm.defaultFields[
                                              _vm.DEFAULT_TPL_FIELDS
                                                .TABLES_RELATIONSHIP.name
                                            ].stringValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultFields[
                                                _vm.DEFAULT_TPL_FIELDS
                                                  .TABLES_RELATIONSHIP.name
                                              ],
                                              "stringValue",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultFields[DEFAULT_TPL_FIELDS.TABLES_RELATIONSHIP.name].stringValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isTableOwnerLogged,
                              expression: "isTableOwnerLogged",
                            },
                          ],
                          attrs: { sm: "12", lg: "3" },
                        },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-4" },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "p-0 font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("my_tasks.modals.files"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-8" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        outlined: "",
                                        color: "secondary",
                                        rounded: "",
                                        dense: "",
                                        small: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.$refs.fileInput2.$el
                                            .querySelector("input[type=file]")
                                            .click()
                                        },
                                      },
                                    },
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("mdi-paperclip"),
                                      ]),
                                      _vm._v(
                                        _vm._s(_vm.$t("my_tasks.modals.attach"))
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("b-form-file", {
                                    ref: "fileInput2",
                                    staticStyle: { display: "none" },
                                    attrs: {
                                      accept:
                                        _vm.METADATA_FILE_FORMAT.join(","),
                                    },
                                    on: { change: _vm.onFileChange },
                                    model: {
                                      value: _vm.inputUploadFile,
                                      callback: function ($$v) {
                                        _vm.inputUploadFile = $$v
                                      },
                                      expression: "inputUploadFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.files.length,
                              expression: "files.length",
                            },
                          ],
                          attrs: { sm: "12", lg: "4" },
                        },
                        [
                          _c(
                            "b-table-simple",
                            { attrs: { small: true, hover: true } },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c(
                                    "b-tr",
                                    [
                                      _c("b-th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("my_tasks.modals.files")
                                          )
                                        ),
                                      ]),
                                      _c("b-th", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.isTableOwnerLogged,
                                            expression: "isTableOwnerLogged",
                                          },
                                        ],
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-tbody",
                                _vm._l(_vm.files, function (file, index) {
                                  return _c(
                                    "b-tr",
                                    { key: index },
                                    [
                                      _c("b-td", [
                                        _vm.METADATA_IMAGE_FORMAT.filter(
                                          function (format) {
                                            return file.fileName
                                              .toLowerCase()
                                              .endsWith(format)
                                          }
                                        ).length
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onClickLink(file)
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(file.fileName))]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                staticStyle: {
                                                  color: "#515154",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openImage(
                                                      file.fileLink
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(file.fileName))]
                                            ),
                                      ]),
                                      _c(
                                        "b-td",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isTableOwnerLogged,
                                              expression: "isTableOwnerLogged",
                                            },
                                          ],
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              attrs: { title: "Delete" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteFile(file)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    color: "blue",
                                                    "font-size": "medium",
                                                  },
                                                },
                                                [_vm._v("delete")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.currentFile.fileLink &&
                                _vm.METADATA_IMAGE_FORMAT.filter(function (
                                  file
                                ) {
                                  return _vm.currentFile.fileName
                                    .toLowerCase()
                                    .endsWith(file)
                                }).length,
                              expression:
                                "currentFile.fileLink && METADATA_IMAGE_FORMAT.filter(file => currentFile.fileName.toLowerCase().endsWith(file)).length",
                            },
                          ],
                          attrs: { sm: "12", lg: "6" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.currentFile.fileLink,
                                download: _vm.currentFile.fileName,
                                target: "_blank",
                              },
                            },
                            [
                              _c("b-img", {
                                attrs: {
                                  src: _vm.currentFile.fileLink,
                                  fluid: "",
                                  alt: _vm.currentFile.fileName,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.defaultFields[_vm.DEFAULT_TPL_FIELDS.DESCRIPTION.name]
                    ? _c(
                        VRow,
                        { attrs: { dense: "" } },
                        [
                          _c(VCol, { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "pb-2 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("my_tasks.modals.table_desc")) +
                                    ":"
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            VCol,
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  "hide-details": "auto",
                                  placeholder: _vm.$t("my_tasks.modals.files"),
                                  readonly: !_vm.isEdited("DESCRIPTION"),
                                  filled: !_vm.isEdited("DESCRIPTION"),
                                  outlined: _vm.isEdited("DESCRIPTION"),
                                  rules:
                                    _vm.defaultFields[
                                      _vm.DEFAULT_TPL_FIELDS.ENVIRONMENT.name
                                    ].enumValue.displayName == "prod"
                                      ? [
                                          function (v) {
                                            return (
                                              (v !== "Null" && !!v) ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                          _vm.unicodeCharLimit,
                                        ]
                                      : [_vm.unicodeCharLimit],
                                  "persistent-hint": "",
                                },
                                on: { input: _vm.handleInput },
                                model: {
                                  value: _vm.completeDescription,
                                  callback: function ($$v) {
                                    _vm.completeDescription = $$v
                                  },
                                  expression: "completeDescription",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  key: _vm.key_description,
                                  staticClass: "text-right",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.DESC_CHARACTERS_COUNT) +
                                      " / " +
                                      _vm._s(_vm.MAX_CHARACTERS)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                VTabItem,
                [
                  _c("list-table-metadata-cols", {
                    ref: "formtable",
                    attrs: {
                      columnFields: _vm.columnFields,
                      defaultFields: _vm.defaultFields,
                      isChangeRequest: _vm.isChangeRequest,
                      filter: _vm.filter,
                    },
                  }),
                ],
                1
              ),
              _c(
                VTabItem,
                [
                  _c("tab-metadata-business-terms-component", {
                    attrs: {
                      columnFields: _vm.columnFields,
                      relativeResourceName: _vm.relativeResourceName,
                      domainTable: _vm.domain_table,
                      validUserAccess: _vm.validUserAccess,
                      isChangeRequest: _vm.isChangeRequest,
                      dataOperator:
                        _vm.defaultFields[_vm.DEFAULT_TPL_FIELDS.OPERATOR.name]
                          .stringValue,
                    },
                    on: { cancel2: _vm.onCancel },
                  }),
                ],
                1
              ),
              _vm.source == "bigquery"
                ? _c(
                    VTabItem,
                    [
                      _vm.isLoadingProfilingRules
                        ? [_c("base-loading")]
                        : _c(
                            "b-container",
                            { attrs: { fluid: "" } },
                            [
                              _vm.selectProfilingRules.length === 0 ||
                              !_vm.isProd()
                                ? _c("b-row", { staticClass: "form-row" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("my_tasks.modals.no_profiling")
                                        )
                                      ),
                                    ]),
                                  ])
                                : _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "pl-1" },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                VCol,
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c(
                                                    VSubheader,
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s("Profiling Rule")
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VCol,
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(VSelect, {
                                                    attrs: {
                                                      id: "rule-input",
                                                      size: "sm",
                                                      options:
                                                        _vm.selectProfilingRules,
                                                      "item-value":
                                                        "document_id",
                                                      "item-text": "format",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.getExecutions()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.currentRule,
                                                      callback: function ($$v) {
                                                        _vm.currentRule = $$v
                                                      },
                                                      expression: "currentRule",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      !_vm.isLoadingExecutions
                                        ? _c(
                                            "b-row",
                                            [
                                              _c("profiling-table-result", {
                                                attrs: {
                                                  documentId: _vm.currentRule,
                                                  domainTable: _vm.domain_table,
                                                  tableReference:
                                                    _vm.tplToWork.item
                                                      .tableReference,
                                                  readonly:
                                                    !_vm.isTableOwnerLogged,
                                                },
                                                on: {
                                                  closeModal: function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit("cancel")
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            { attrs: { sm: "12" } },
                                            [_c("base-loading")],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                VTabItem,
                [
                  _c(
                    VContainer,
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { sm: "12" } },
                            [
                              _c("LineageComponent", {
                                attrs: { table: _vm.tplToWork },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VTabItem,
                [
                  _c(
                    VContainer,
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        VRow,
                        [
                          _c(VCol, { attrs: { sm: "12" } }),
                          _c("list-table-logs", {
                            ref: "refTableLog",
                            attrs: {
                              objectId: _vm.tplToWork.item.relativeResourceName,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.current !== "bterm",
                  expression: "current !== 'bterm'",
                },
              ],
            },
            [
              _vm.tplToWork.tipo == "vista"
                ? [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12", lg: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "sm",
                                  label: "Request reason",
                                },
                              },
                              [
                                _c("b-form-textarea", {
                                  staticClass: "input-mini",
                                  attrs: {
                                    disabled: "",
                                    size: "sm",
                                    rows: "3",
                                    "max-rows": "3",
                                    type: "text",
                                    required: "",
                                    placeholder: "Message to request...",
                                  },
                                  model: {
                                    value: _vm.tplToWork.item.commentary,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tplToWork.item,
                                        "commentary",
                                        $$v
                                      )
                                    },
                                    expression: "tplToWork.item.commentary",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12", lg: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "sm",
                                  label: _vm.$t(
                                    "my_tasks.modals.response_reason"
                                  ),
                                },
                              },
                              [
                                _c("b-form-textarea", {
                                  staticClass: "input-mini",
                                  attrs: {
                                    disabled: "",
                                    size: "sm",
                                    rows: "3",
                                    "max-rows": "3",
                                    type: "text",
                                    required: "",
                                    placeholder: "Message to response...",
                                  },
                                  model: {
                                    value: _vm.tplToWork.item.response,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tplToWork.item,
                                        "response",
                                        $$v
                                      )
                                    },
                                    expression: "tplToWork.item.response",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.tplToWork.tipo != "vista"
                ? [
                    _vm.isChangeRequest ==
                      _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST &&
                    _vm.tplToWork.tipo == "edicion"
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12", lg: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: "Request reason",
                                    },
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      attrs: {
                                        size: "sm",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        required: "",
                                        placeholder: "Message to request...",
                                      },
                                      model: {
                                        value: _vm.tplToWork.commentary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tplToWork,
                                            "commentary",
                                            $$v
                                          )
                                        },
                                        expression: "tplToWork.commentary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isChangeRequest == _vm.TYPE_CHANGE_METADA.PREVIEW_OWNER
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "12", lg: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      "label-size": "sm",
                                      label: _vm.$t(
                                        "my_tasks.modals.response_reason"
                                      ),
                                    },
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      staticClass: "input-mini",
                                      attrs: {
                                        size: "sm",
                                        rows: "3",
                                        "max-rows": "3",
                                        type: "text",
                                        required: "",
                                        placeholder: "Message to response...",
                                      },
                                      model: {
                                        value: _vm.tplToWork.response,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tplToWork,
                                            "response",
                                            $$v
                                          )
                                        },
                                        expression: "tplToWork.response",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12", lg: "12" } },
                          [
                            _c(
                              "b-alert",
                              {
                                attrs: {
                                  show: _vm.dismissCountDown,
                                  dismissible: "",
                                  variant: "danger",
                                },
                                on: {
                                  dismissed: function ($event) {
                                    _vm.dismissCountDown = 0
                                  },
                                  "dismiss-count-down": _vm.countDownChanged,
                                },
                              },
                              [
                                _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                                _c("b-progress", {
                                  attrs: {
                                    variant: "danger",
                                    max: _vm.dismissSecs,
                                    value: _vm.dismissCountDown,
                                    height: "4px",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }